/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TargetCrosshairIcon16Light = forwardRef('TargetCrosshairIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 7.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM2.022 7A5.502 5.502 0 0 1 7 2.022V4.5a.5.5 0 0 0 1 0V2.022A5.502 5.502 0 0 1 12.978 7H10.5a.5.5 0 0 0 0 1h2.478A5.502 5.502 0 0 1 8 12.978V10.5a.5.5 0 0 0-1 0v2.478A5.502 5.502 0 0 1 2.022 8H4.5a.5.5 0 0 0 0-1H2.022Z" })));
});
